'use client';

import { useParams, useRouter } from "next/navigation";
import { blogs } from "@/data/blogData";
import CustomButton from "@/components/CustomButton";

export default function BlogPage() {
    const router = useRouter();
    const { slug } = useParams();
    const blog = blogs.find((b) => b.slug === slug);

    if (!blog) {
        return (
            <div className="flex h-screen flex-col items-center justify-center gap-8 bg-gray-950 text-center">
                <h2 className="text-4xl font-bold text-white">Blog Not Found</h2>
                <CustomButton onClick={() => router.push("/")}>Go Back Home</CustomButton>
            </div>
        );
    }

    return (
        <main className="min-h-screen bg-gray-950 text-white">
            <article className="wrapper blog-content">
                <img
                    src={blog.coverImage}
                    alt={blog.title}
                    className="mb-10 rounded-2xl object-cover shadow-lg"
                />

                <h1 className="mb-4 text-4xl font-extrabold tracking-tight lg:text-5xl">{blog.title}</h1>
                <p className="mb-6 text-sm text-gray-400">{blog.date} • By {blog.author}</p>

                <div
                    className="prose prose-invert prose-lg max-w-none"
                    dangerouslySetInnerHTML={{ __html: blog.content }}
                />
            </article>
        </main>
    );
}
